module.exports = __webpack_public_path__ + "img/shopping_cart.ad9c221c.png";